import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable()
export class FormsService {

  constructor() { }

  public hasSpecificError(form: FormGroup, field: string, validator: string) {
    const control = form.controls[field];
    return control.hasError(validator)
      && control.touched;
  }

  public hasError(form: FormGroup, field: string): boolean {
    const control = form.controls[field];
    return !control.disabled && !control.valid && control.touched;
  }

  /**
   * It returns false if form is invalid and true if it valid.
   * If it's invalid we refresh validation and show the errors.
   */
  public validateFormAndUpdateErrors(formGroup: FormGroup): boolean {
    formGroup.updateValueAndValidity();

    if (formGroup.invalid) {
      Object.keys(formGroup.controls).forEach(key => {
        formGroup.get(key).markAsTouched();
      });
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/forms.service.ts